import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from '../ui/Button';
import { ThemeToggle } from '../ui/ThemeToggle';
import { WorkspaceBreadcrumbs } from './status/WorkspaceBreadcrumbs';
import { UserNavMenu } from './status/UserNavMenu';
import { CreateOrgModal } from './status/CreateOrgModal';
import { CreateProjectModal } from './status/CreateProjectModal';

export interface TopStatusBarProps {
  onToggleMobileNav?: () => void;
  mobileNavOpen?: boolean;
}

export const TopStatusBar: React.FC<TopStatusBarProps> = ({
  onToggleMobileNav,
  mobileNavOpen = false,
}) => {
  const [createOrgOpen, setCreateOrgOpen] = useState(false);
  const [createProjOpen, setCreateProjOpen] = useState(false);

  return (
    <>
      <header className="h-12 bg-white dark:bg-[#2e2f3b] bg-cf-nav border-b border-cf-border px-3 sm:px-4 flex items-center justify-between z-30 sticky top-0 flex-shrink-0">
        {/* Left: Interactive Breadcrumbs */}
        <div className="flex items-center min-w-0 flex-1 py-1 mr-2">
          <WorkspaceBreadcrumbs
            onOpenCreateOrg={() => setCreateOrgOpen(true)}
            onOpenCreateProj={() => setCreateProjOpen(true)}
          />
        </div>

        {/* Right: Theme Toggle, User Profile & Mobile Nav */}
        <div className="flex items-center gap-2.5">
          <ThemeToggle />
          <UserNavMenu />

          {/* Mobile Navigation Menu Toggle */}
          <Button
            type="button"
            variant="ghost"
            size="icon"
            onClick={onToggleMobileNav}
            aria-label="Toggle Navigation Menu"
            className="md:hidden -mr-1"
          >
            {mobileNavOpen ? <X size={18} /> : <Menu size={18} />}
          </Button>
        </div>
      </header>

      {/* Header Create Organization Modal */}
      <CreateOrgModal
        isOpen={createOrgOpen}
        onClose={() => setCreateOrgOpen(false)}
      />

      {/* Header Create Project Modal */}
      <CreateProjectModal
        isOpen={createProjOpen}
        onClose={() => setCreateProjOpen(false)}
      />
    </>
  );
};
